import { module } from 'stereomodularjs';
import { SplitText } from '../utils/SplitText.js';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (this.el) {
            // console.log(SplitText);
            this.splitLine = new SplitText(this.el, { type: 'lines', linesClass: "o-line" });
            // UNCOMMENT TO WRAP INSIDE .o-line
            // this.el.querySelectorAll('div').forEach(function(element) {
            //     element.innerHTML = '<span class="o-line-child">'+element.innerHTML+'</span>';
            // })
        }
    }

    destroy() {
        try {
            this.splitLine.destroy();
        } catch (e) { }
    }
}